module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/banco-agencia/banco-agencia.component.css
// module id = ./src/app/banco-agencia/banco-agencia.component.css
// module chunks = main